import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { Typography } from '../../atoms';
import { useTheme } from '../../theme';
export function LogoLoader({ loadingText, height, width }) {
    const theme = useTheme();
    return (_jsxs(Box, { sx: {
            alignItems: 'center',
            justifyContent: 'center',
            height: height ? height : '300px',
            width: width ? width : '300px',
            '& .logo-svg': {
                margin: '0 auto',
                position: 'relative',
                display: 'block',
            },
            '& .logo-svg path': {
                stroke: '#2167AE',
                fillOpacity: '0',
                strokeWidth: '0.5',
                strokeDasharray: '1000',
                strokeDashoffset: '1000',
                MozAnimation: 'DASH 1s linear 0s alternate-reverse infinite',
                WebkitAnimation: 'DASH 1s linear 0s alternate-reverse infinite',
                animation: 'DASH 1s linear 0s alternate-reverse infinite',
            },
            '@keyframes DASH': {
                '0%': {
                    strokeDashoffset: '1000',
                },
                '40%': {
                    strokeDashoffset: '0',
                    fillOpacity: '0',
                },
                '80%, 100%': {
                    strokeDashoffset: '0',
                    fillOpacity: '1',
                },
            },
        }, children: [_jsx("svg", { className: "logo-svg", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 150 150", children: _jsx("path", { d: "M75 12.3c-34 0-61.5 27.6-61.5 61.5 0 14 4.7 27 12.6 37.3l51.1-67.2h-11c-5.8 0-11.3.4-15.3 1.2-2.4.5-4.5 1.3-6.3 2.6-2.1 1.4-4.6 4.5-6.3 7.4-.2.3-.5.9-.8 1.6l-3-.7 5-19.3h64.1l-50.9 68.1c3.3-.3 4.6-.4 7.3-.4 2.1 0 5.2.1 9.4.4l9 .5c3.3.2 6 .3 8.1.3 4.7 0 7.7-.4 10.7-1.3 2.3-.7 4.6-1.8 6.6-3.2 3.6-2.5 7.1-6.4 9.1-10.4l.9-1.8 2.7.7c-.9 3.4-1.4 4.6-2.7 7.7-2.7 6.1-5.8 10.2-10.1 13.3-4.4 3.2-9.2 4.8-14.9 4.9h-.9c-4.2 0-7.5-.4-17.6-1.9-10.3-1.6-15.5-2.1-20.7-2.1-3.5 0-6.7.3-10 .8-4.4.7-6.1 1.2-10.2 3 11.2 12.3 27.4 20 45.3 20 34 0 61.5-27.5 61.5-61.5.3-34-27.2-61.5-61.2-61.5z", fill: theme.palette.primary.main }) }), !!loadingText && (_jsx(Typography, { align: "center", variant: "h3", color: "darkBlue", children: loadingText }))] }));
}
